import { EQuestPartsType } from '@devHubSingleQuest/components/DevHubSingleQuestPage/DevHubSingleQuestPage.enum';
import { useAtom } from 'jotai';
import { questPartControlTypeAtom } from '../devhubSingleQuestStore.atoms';

export function useGetQuestPartControlType() {
	const [value] = useAtom(questPartControlTypeAtom);
	return [value];
}

export function useSetQuestPartControlType(): [undefined, (payload: EQuestPartsType) => void] {
	const [, set] = useAtom(questPartControlTypeAtom);
	return [, set];
}
